import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
const VuexLocal = new VuexPersistence({
  storage: window.localStorage
}); // https://github.com/championswimmer/vuex-persist vuex的本地持久化插件

// 通用Module
import common from './module/common'; 
import exhibitionModule from './module/exhibitionModule'  // 展会模块 
import home from './module/home'  // 首页 
import exhibitor from './module/exhibitor'  // 产品&展商
import linkTo from './module/linkTo'  // 路由跳转
import hall from './module/hall'  // 路由跳转
import loginModule from './module/loginModule'  // 路由跳转
import contactUs from './module/contactUs' 
// 组件Module 

const Modele = { 
  exhibitionModule,
  loginModule,
  home,
  contactUs,
  exhibitor,
  hall,
  linkTo, 
}; 

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    ...common.state, // 通用 state 
  },
  getters: {
    ...common.getters, // 通用 getters  
  },
  mutations: {
    ...common.mutations, // 通用 mutations 
  },
  modules: {
    ...Modele, 
  },
  actions: {
    ...common.actions // 通用 actions
  },
  plugins: [VuexLocal.plugin]
})